import type { UuidB62 } from '@utils/id'

export interface PzApiBaseReqData {
  authenticatedUserId: UuidB62
}

// -------------------------------------------------------------------

export const pzApiSpacesSlug = 'spaces'
